const translations = [
  ['&copy;', String.fromCharCode(169)],
  ['&reg;', String.fromCharCode(174)],
  ['&trade;', String.fromCharCode(8482)],
];

const translateHtmlEntities = (str) =>
  translations.reduce((string, [entity, char]) => string.replace(entity, char), str || '');

export { translateHtmlEntities };
